import { render, staticRenderFns } from "./QjListTemplateWhatsApp.vue?vue&type=template&id=67613c25"
import script from "./QjListTemplateWhatsApp.vue?vue&type=script&lang=js"
export * from "./QjListTemplateWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./QjListTemplateWhatsApp.vue?vue&type=style&index=0&id=67613c25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports